import { jsxs, jsx } from "react/jsx-runtime";
import { getEntityImage } from "../../utils/assetUtils.js";
import { cn } from "../../lib/utils.js";
const ConciergeRetailerIconGroup = ({
  retailerIds,
  maxSize = 4,
  iconSize = 18,
  buildUnrenderedIconCountString = (hiddenIconCount) => `+${hiddenIconCount}`
}) => {
  const retailerIdsToRender = retailerIds.slice(0, maxSize);
  const hiddenIconCount = retailerIds.length - maxSize;
  const containerWidth = retailerIdsToRender.length * iconSize - iconSize * 0.46 * (retailerIdsToRender.length - 1);
  return /* @__PURE__ */ jsxs("div", { className: cn("tw:flex tw:items-center"), style: { isolation: "isolate" }, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "tw:flex tw:items-center",
        style: {
          width: `${containerWidth}px`
        },
        children: retailerIdsToRender.map((retailerId, index) => {
          const shiftOffset = iconSize * 0.46;
          return /* @__PURE__ */ jsx(
            "img",
            {
              src: getEntityImage(retailerId, "retailer"),
              alt: "retailer-logo",
              className: "tw:object-contain tw:rounded-full tw:relative",
              style: {
                width: `${iconSize}px`,
                height: `${iconSize}px`,
                left: `${-shiftOffset * index}px`,
                zIndex: `${retailerIdsToRender.length - index}`,
                mixBlendMode: "normal"
                // Override parent's multiply blend mode
              }
            },
            `retailer-logo-${retailerId}-${index}`
          );
        })
      }
    ),
    hiddenIconCount >= 1 ? /* @__PURE__ */ jsx("div", { className: "tw:ml-[7px] tw:font-semibold tw:text-[11px]", children: buildUnrenderedIconCountString(hiddenIconCount) }) : null
  ] });
};
export {
  ConciergeRetailerIconGroup
};
//# sourceMappingURL=ConciergeRetailerIconGroup.js.map
